import Icons from '../../../components/icons';
import { PaymentConcessionType } from '../../../enums';
import { ConcessionType } from '../types';

export const concessionTypeTabs: {
  key: ConcessionType;
  label: string;
  IconActive: React.ElementType;
  IconInactive: React.ElementType;
}[] = [
  {
    key: 'rollover',
    label: 'Rollover',
    IconActive: Icons.RolloverOutlined,
    IconInactive: Icons.RolloverOutlinedBlack
  },
  {
    key: 'newAdmission',
    label: 'New Admission',
    IconActive: Icons.NewAdmissionOutlined,
    IconInactive: Icons.NewAdmissionOutlinedBlack
  }
];

export const concessionTypeOptions = [
  { label: 'Fixed Percentage', value: PaymentConcessionType.FIXED_PERCENTAGE },
  { label: 'Fixed Amount', value: PaymentConcessionType.FIXED_AMOUNT },
  {
    label: 'Date Wise Percentage',
    value: PaymentConcessionType.DATE_WISE_PERCENTAGE
  },
  { label: 'Date Wise Amount', value: PaymentConcessionType.DATE_WISE_AMOUNT }
];

export const applicableOnOptions = [
  { label: 'Tuition Fee', value: 'Tuition Fee' },
  { label: 'Part A', value: 'Part A' }
];
